import { Link } from 'react-router-dom';

export default function WhatIsSection() {
  return (
    <section className="bg-[#f8fafc] py-16 px-6 border-b border-gray-100">
      <div className="max-w-[1280px] mx-auto">
        <h2 className="text-2xl font-bold text-center text-[#1a1a2e] mb-3">Özel Bulut İşletim Sistemi Nedir?</h2>
        <p className="text-center text-sm text-[#64748b] max-w-2xl mx-auto mb-12 leading-relaxed">
          Özel Bulut İşletim Sistemi <strong>tüm veri merkezini sanallaştırır</strong> — işlem, depolama, ağ, yedekleme ve felaket kurtarma —
          tek bir işletim sistemi altında standart x86 sunucularda çalışır. Beş farklı satıcıdan beş ürün bir araya getirmek yerine,
          ekibiniz her şeyi tek bir platform üzerinden tek bir konsol ile yönetir. Fark şöyle görünüyor:
        </p>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 max-w-4xl mx-auto mb-8">
          {/* VergeOS Öncesi */}
          <div className="bg-white border border-red-100 rounded-lg p-6">
            <div className="text-xs font-bold text-[#64748b] uppercase tracking-wider mb-4 pb-2 border-b border-gray-100">
              VergeOS Öncesi
            </div>
            <ul className="space-y-3">
              {[
                { item: 'Hypervisor', vendor: 'Satıcı 1' },
                { item: 'Depolama Dizisi veya vSAN', vendor: 'Satıcı 2' },
                { item: 'Ağ Katmanı', vendor: 'Satıcı 3' },
                { item: 'Yedekleme Yazılımı', vendor: 'Satıcı 4' },
                { item: 'DR & Güvenlik Araçları', vendor: 'Satıcı 5' },
              ].map(({ item, vendor }) => (
                <li key={item} className="flex items-center justify-between text-sm">
                  <span className="text-[#374151]">{item}</span>
                  <span className="text-xs text-[#94a3b8] bg-gray-50 px-2 py-0.5 rounded">{vendor}</span>
                </li>
              ))}
            </ul>
            <p className="mt-4 text-xs text-[#94a3b8] italic">
              Beş satıcı. Beş konsol. Beş yenileme döngüsü. Her entegrasyon noktası potansiyel bir kırılma noktasıdır.
            </p>
          </div>

          {/* VergeOS İle */}
          <div className="bg-white border border-green-100 rounded-lg p-6">
            <div className="text-xs font-bold text-[#e8600a] uppercase tracking-wider mb-4 pb-2 border-b border-orange-100">
              VergeOS İle
            </div>
            <ul className="space-y-3">
              {[
                'İşlem ve Sanallaştırma',
                'Depolama (VergeFS)',
                'Ağ Yönetimi (VergeFabric)',
                'Yedekleme ve Anlık Görüntüler',
                'DR & Fidye Yazılımı Koruması',
              ].map((item) => (
                <li key={item} className="flex items-center gap-2 text-sm">
                  <i className="ri-checkbox-circle-fill text-green-500 text-base flex-shrink-0"></i>
                  <span className="text-[#374151]">{item}</span>
                </li>
              ))}
            </ul>
            <p className="mt-4 text-xs text-[#64748b]">
              Tek işletim sistemi. Tek konsol. Çekirdek seviyesinde entegre. Standart x86 sunucular. Donanım yenileme döngüsü yok.
            </p>
          </div>
        </div>

        <p className="text-center text-sm text-[#64748b]">
          Bir{' '}
          <Link to="/ozel-bulut-os" className="text-[#e8600a] hover:underline cursor-pointer">
            Özel Bulut İşletim Sistemi
          </Link>
          {' '}avantajları hakkında daha fazla bilgi edinin
        </p>
      </div>
    </section>
  );
}
